import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { AssetService } from '../../Model/AssetModule/asset.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-asset-group-master-form',
  standalone: true,
  imports: [CommonModule,FormsModule],
  templateUrl: './asset-group-master-form.component.html',
  styleUrl: './asset-group-master-form.component.scss'
})
export class AssetGroupMasterFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;
  Group = [] as any;
  GroupDetail = {
    SelectType:'Insert',
    ESS_AssetGroupMasterID: 0,
    AssetGroupName: null,
    AssetGroupCode:null,
    Description: null,
  }
  constructor(
    private toast: ToastService,
    private Asset: AssetService,
    private modalService: NgbModal

  ) {
    this.GroupDetail.ESS_AssetGroupMasterID = this.ID;
  }
  ngOnInit(): void {
    if (this.ID > 0) {
      this.GetGroupAsset();
    }
  }
  Validate(form: any) {
    if (form.valid) {
      if (this.GroupDetail.AssetGroupName != null && this.GroupDetail.Description != null) {
        this.SaveGroupMaster();
      }
    }
    else {
      form.submitted = true;
    }
  }
  GetGroupAsset() {
    this.isDisabled = true;
    this.GroupDetail.ESS_AssetGroupMasterID = this.ID;
    this.Asset.LoadGroupMaster({ ESS_AssetGroupMasterId: this.GroupDetail.ESS_AssetGroupMasterID, SelectType: 1 }).subscribe({
      next: (response) => {
        this.GroupDetail=response[0];
        console.log(response);
        this.GroupDetail.SelectType = 'update';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  SaveGroupMaster() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result) => {
      if (result) {
        this.isDisabled = true;
        this.GroupDetail.ESS_AssetGroupMasterID = this.ID;
        this.Asset.InsertUpdateAssetGroup(this.GroupDetail).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              this.activeModal.close();
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
            }
            else {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
            }
            
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });


  }
  close() {
    this.activeModal.close();
  }


}
